import React from 'react'
import useAppContext from '../../hook/useAppContext'
import HeaderSection from '../../components/headersection/HeaderSection'
import SocialMenu from '../../components/social/SocialMenu'
import './about.css'

const About = () => {

      const {user, data, break_line} = useAppContext()
      const {personal, social} = user 

      const about = personal.code || personal.about.length === 0 ? data.info.about : personal.about
      const xat_room = personal.code || personal.xat_room.length === 0 ? data.info.xat_room : personal.xat_room
      const homepage = personal.code || personal.homepage.length === 0 ? data.info.homepage : personal.homepage
      const forum = personal.code || personal.forum.length === 0 ? data.info.forum : personal.forum

      return (
            <div className="about_content aside">
                  <HeaderSection title= {`About Us`}/>
                  <div className="about_description">
                        <p>{break_line(about)}</p>
                  </div>
                  <div className="about_media__menu flex">
                        <a className="btn_effect" href={xat_room} target="_blank" rel="noreferrer"><span>Chat</span></a>
                        <a className="btn_effect" href={forum} target="_blank" rel="noreferrer"><span>Forum</span></a>
                        <a className="btn_effect" href={homepage} target="_blank" rel="noreferrer"><span>Web</span></a>
                  </div>
                  <div className="about_social__media">
                        <SocialMenu social={social}/>
                  </div>
            </div>
      )
}

export default About
